import React from 'react';
import { Images } from 'utils';
import { CustomDelete, MinLoader } from 'components';

/** The "Edit Session Data?" confirmation that opens edit mode (Figma "Edit Session Data" → Modal). */
export const EditSessionDataConfirm = ({ onConfirm, onClose }) => (
    <CustomDelete
        info="Edit Session Data?"
        text="This session is already completed. Editing collected data may change goal progress and mastery results. After you save your changes, the session will be re-completed and mastery will be recalculated."
        innerText="Edit Data"
        color="blue"
        handleClose={onClose}
        handleDel={onConfirm}
    />
);

/** Amber bar under the header while edit mode is on, holding the mode's Cancel / Save actions. */
export const EditSessionDataBanner = ({ dirty, saving, onCancel, onSave }) => (
    <div className="edit-session-data-banner">
        <div className="edit-session-data-banner-text">
            <img src={Images.alertWarning} alt="" />
            <p>
                <span className="edit-session-data-banner-title">Editing completed session data</span>
                Changes may affect goal progress and mastery.
            </p>
        </div>

        <div className="edit-session-data-banner-actions">
            <button type="button" className="edit-session-data-cancel-btn" disabled={saving} onClick={onCancel}>
                Cancel Changes
            </button>
            <button
                type="button"
                className="edit-session-data-save-btn"
                disabled={!dirty || saving}
                style={{ opacity: dirty ? 1 : 0.5, width: 165 }}
                onClick={onSave}
            >
                {saving ? <MinLoader margin={'0'} color={'#FFF'} position={'relative'} /> : 'Save & Re-complete'}
            </button>
        </div>
    </div>
);
